import React, {PureComponent} from "react"
import styled from "styled-components"

import {greys} from "@irati/ui/src/global/colors"
import {CompanyValue} from "@irati/companyvalues/types"
import Icon, {IconTypes} from "@irati/ui/src/Icon"

interface Props {
  companyValue: CompanyValue
}

interface StyledProps {
  archived: boolean
}

const StyledIcon = styled<StyledProps, Icon>(Icon)`
  opacity: ${({archived}) => (archived ? "0.3" : "1")};
  position: relative;
  top: 1px;
`

const CompanyValueLabel = styled<StyledProps, "div">("div")`
  background: ${({archived}) => (archived ? greys.lightest : greys.white)};
  border-radius: 3px;
  border: 1px solid ${greys.light};
  color: ${({archived}) => (archived ? greys.medium : greys.dark)};
  display: flex;
  margin: 5px 5px 0 0;
  padding: 2px 6px 2px 2px;
  text-transform: uppercase;
`

class CompanyValueTag extends PureComponent<Props> {
  render() {
    const {archived, tag} = this.props.companyValue
    return (
      <CompanyValueLabel archived={archived}>
        <StyledIcon archived={archived} icon={IconTypes.label} large marginRight />
        {tag}
      </CompanyValueLabel>
    )
  }
}

export default CompanyValueTag
